/**
 * Rogue Industries — performance helpers
 */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
   * Stamped.io: load only when reviews badge enters viewport
   * ------------------------------------------------------------------ */
  function loadStamped() {
    if (window.__stampedLoaded) return;
    window.__stampedLoaded = true;

    var s = document.createElement('script');
    s.src = 'https://cdn1.stamped.io/files/widget.min.js';
    s.async = true;
    s.onload = function () {
      if (window.StampedFn) {
        StampedFn.init({ apiKey: 'pubkey-DE4VVd0cB69u37u6Bm099pf96lT6T5', sId: '86631' });
      }
    };
    document.head.appendChild(s);
  }

  function initStampedLazyLoad() {
    var target = document.querySelector('.stamped-product-reviews-badge, #stamped-main-widget, .stamped-reviews-widget');

    if (!target) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          loadStamped();
          observer.disconnect();
        }
      }, { rootMargin: '300px' });
      observer.observe(target);
    } else {
      window.addEventListener('load', loadStamped);
    }
  }

  /* ------------------------------------------------------------------
   * Product media: inject video/iframe/model only when slide is active
   * Prevents 13MB+ video downloads on initial page load
   * ------------------------------------------------------------------ */
  function activateDeferredMedia(container) {
    if (!container || container.dataset.mediaActivated === 'true') return;
    container.dataset.mediaActivated = 'true';

    var template = container.querySelector('.Product__DeferredMediaTemplate');
    if (template && template.content) {
      container.innerHTML = '';
      container.appendChild(template.content.cloneNode(true));
      return;
    }

    if (container.hasAttribute('data-deferred-external-video')) {
      var slide = container.closest('.Product__SlideItem');
      if (!slide) return;

      var host = slide.getAttribute('data-video-host');
      var videoId = slide.getAttribute('data-video-id');
      if (!host || !videoId) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'VideoWrapper';

      if (host === 'youtube') {
        wrapper.innerHTML = '<iframe src="https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen frameborder="0"></iframe>';
      } else if (host === 'vimeo') {
        wrapper.innerHTML = '<iframe src="https://player.vimeo.com/video/' + videoId + '?autoplay=1" allow="autoplay; encrypted-media" allowfullscreen frameborder="0"></iframe>';
      }

      container.innerHTML = '';
      container.appendChild(wrapper);
    }
  }

  function initProductDeferredMedia() {
    var gallery = document.querySelector('.Product__Gallery');
    if (!gallery) return;

    function activateSelectedSlideMedia() {
      var selected = gallery.querySelector('.Product__SlideItem.is-selected');
      if (!selected) return;

      var deferred = selected.querySelector('[data-deferred-video], [data-deferred-external-video], [data-deferred-model]');
      if (deferred) activateDeferredMedia(deferred);
    }

    gallery.addEventListener('click', function (event) {
      var deferred = event.target.closest('[data-deferred-video], [data-deferred-external-video], [data-deferred-model]');
      if (deferred) activateDeferredMedia(deferred);
    });

    gallery.addEventListener('click', function (event) {
      var thumb = event.target.closest('.Product__SlideshowNavImage');
      if (!thumb) return;
      setTimeout(activateSelectedSlideMedia, 50);
    });

    var slideshow = gallery.querySelector('.Product__Slideshow');
    if (slideshow) {
      var observer = new MutationObserver(function () {
        activateSelectedSlideMedia();
      });
      observer.observe(slideshow, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    activateSelectedSlideMedia();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initStampedLazyLoad();
    initProductDeferredMedia();
  });
})();
